import type { PrinterView } from '../../../../services/printers/printers.service';
import { billablePrinters, resolveFixedPrinter } from '../../hooks/fixed-printer.util';

export const REPORT_PRINTER_STORAGE_KEY = 'posReportPrinterId';

// Auto-Z uses the pinned printer only while it remains billable; otherwise retain the
// existing unpinned billable/main-printer fallback because unattended flows cannot ask.
export function pickAutoZPrinter(printers: PrinterView[]): PrinterView | null {
  const fixedId = resolveFixedPrinter(printers);
  if (fixedId != null) {
    const fixed = printers.find((printer) => printer.id === fixedId);
    if (fixed?.billable) return fixed;
  }
  const billables = billablePrinters(printers);
  if (billables.length === 1) return billables[0];
  return printers.find((printer) => printer.active && printer.mainPrinter) ?? null;
}
